/**
 * The EIP-191 messages the admin wallet signs. xbit-relay is a passthrough — it never builds or
 * verifies these — so wallet-service owns the formats and this file is the only place they live.
 *
 * A wrong string does not error: it recovers a different signer and the call comes back as
 * `200 {"success": false}`.
 *
 * All three actions share one format:
 *
 *     Withdrawal ID: <uuid>
 *     Action: Approve|Reject|Resolve
 *     Timestamp: <ms>
 *
 * Note what is NOT signed: `expected_amount`, `reason`, `resolution` and `dst_tx_hash` all go in
 * the request body but stay out of the message. Do not add them back — an extra line changes the
 * recovered signer. The id is labelled `Withdrawal ID` because these reuse wallet-service's
 * signed-withdrawal path; the value is the rebalance UUID in every case.
 *
 * Because `resolution` is unsigned, a signature is not bound to DONE vs FAILED — the freshness
 * window on `timestamp_ms` is what limits it. That is wallet-service's design, not something the
 * FE can tighten; just never reuse a signature across submissions.
 */
export type ApproveMessageParts = {
  id: string;
  timestampMs: number;
};

export const buildApproveRebalanceMessage = ({ id, timestampMs }: ApproveMessageParts): string =>
  `Withdrawal ID: ${id}\nAction: Approve\nTimestamp: ${timestampMs}`;

export type RejectMessageParts = {
  id: string;
  timestampMs: number;
};

export const buildRejectRebalanceMessage = ({ id, timestampMs }: RejectMessageParts): string =>
  `Withdrawal ID: ${id}\nAction: Reject\nTimestamp: ${timestampMs}`;

export type ResolveMessageParts = {
  id: string;
  timestampMs: number;
};

export const buildResolveRebalanceMessage = ({ id, timestampMs }: ResolveMessageParts): string =>
  `Withdrawal ID: ${id}\nAction: Resolve\nTimestamp: ${timestampMs}`;
